var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGetStronger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 640,
    viewBox: "0 0 640 640",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a-97"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 320,
    r: 320,
    transform: "translate(390 119)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-747 -202)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 320,
    r: 320,
    transform: "translate(747 202)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357 83)",
    clipPath: "url(#a-97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.779,384.128l-28.972-36.216L568.077,273.67l83.3-88.728s18.108-68.81,1.811-65.188-19.919,54.323-19.919,54.323L528.24,255.562S539.1,369.641,569.888,409.479l23.54,74.242Z",
    transform: "translate(51.789 138.409)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.37,384.128l28.972-36.216,21.729-74.242-83.3-88.728s-18.108-68.81-1.811-65.188,19.919,54.323,19.919,54.323l105.025,81.485s-10.865,114.079-41.648,153.916l-23.54,74.242Z",
    transform: "translate(94.87 138.409)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.631,260.815s1.811,38.026-9.054,50.7-21.729,77.864,30.783,79.674,47.08-54.323,47.08-54.323l-10.865-30.783s-16.3-23.54-10.865-45.27Z",
    transform: "translate(82.044 209.209)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.645,323.648,620.39,289.5l-19.138,8.772-19.918,63.377s-16.3,30.783,3.622,63.377c0,0,3.622,21.729-1.811,27.162s-7.243,39.837-7.243,39.837l-23.54,45.27s134,23.54,173.834-9.054c0,0-20.9-77.069-8.229-100.61s14.486-59.628,0-75.925-29.8-58.867-29.8-58.867l-8.769-5.609Z",
    transform: "translate(63.883 222.455)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.799,
    cy: 56.799,
    rx: 56.799,
    ry: 56.799,
    transform: "translate(656.797 371.123)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.09,
    cy: 42.089,
    rx: 42.09,
    ry: 42.089,
    transform: "translate(667.604 404.685)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.829,
    cy: 15.829,
    rx: 15.829,
    ry: 15.829,
    transform: "translate(707.177 350)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.077,485.294S336.9,512.2,299.3,522.265s-.307,66.583-.307,66.583-13.563-20.55,6-42.313S356.037,509.893,353.077,485.294Z",
    transform: "translate(365.168 -102.235)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStronger);
export default __webpack_public_path__ + "static/media/get-stronger.783093edc78c2f8b64cf89a8e29983b4.svg";
export { ForwardRef as ReactComponent };